(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cui-light", [], factory);
	else if(typeof exports === 'object')
		exports["cui-light"] = factory();
	else
		root["cui-light"] = factory();
})(window, function() {
return 